import { Box } from '@mui/material';

/**
 * The rule between two facts on a card meta line — "v1 │ Edited 6/1/2026" — reusing the DS
 * toolbar divider recipe (`--border-width-xs` of `--border-neutral-subtle`, inset to the
 * height of what it separates rather than run full-bleed; design ruling 2026-09-07).
 *
 * Decorative: it separates, never carries meaning, so it is `aria-hidden` — a screen reader
 * hears the two facts in sequence.
 */
export function MetaDivider() {
  return (
    <Box
      aria-hidden
      component="span"
      sx={{
        width: 'var(--border-width-xs)',
        alignSelf: 'center',
        height: '1em',
        backgroundColor: 'var(--border-neutral-subtle)',
        flexShrink: 0
      }}
    />
  );
}
